module.exports = __webpack_public_path__ + "img/fangyuan.e9fa57ef.png";